import axios, {
  AxiosHeaders,
  AxiosRequestConfig,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { HttpError } from "@refinedev/core";
import toast from "react-hot-toast";
import CONFIG from "app-config/config.json";

const AUTH_TOKEN = CONFIG.AUTH_TOKEN;
const BASE_URL = CONFIG.API;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  (request: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem("access-token");

    if (request.headers) {
      request.headers["Authorization"] = `Bearer ${AUTH_TOKEN}`;

      if (token) {
        request.headers["access-token"] = token;
      }
    } else {
      request.headers = new AxiosHeaders({
        Authorization: `Bearer ${AUTH_TOKEN}`,
        "access-token": token,
      });
    }

    return request;
  }
);

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error) => {
    const customError: HttpError = {
      ...error,
      message: error.response?.data?.message,
      statusCode: error.response?.code_status,
    };

    toast.error(customError.message || "Đã xảy ra lỗi!", {
      ...(customError.response?.status === 401
        ? { id: customError.response.status.toString() }
        : {}),
      position: "top-right",
      duration: 6000,
    });

    return Promise.reject(customError);
  }
);

export const request = <T = any>(
  config: AxiosRequestConfig
): Promise<AxiosResponse<T>> => {
  return axiosInstance.request<T>(config);
};
